import { render } from "./WorkshopsPage.vue?vue&type=template&id=5300cf7a&scoped=true"
import script from "./WorkshopsPage.vue?vue&type=script&lang=js"
export * from "./WorkshopsPage.vue?vue&type=script&lang=js"

import "./WorkshopsPage.vue?vue&type=style&index=0&id=5300cf7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5300cf7a"]])

export default __exports__